import React, { PureComponent } from 'react';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import { ButtonPrimary } from 'components/buttons';
import { ErrorAlert, InfoAlert, SpinnerAlert, WarningAlert, SuccessAlert } from 'components/alerts';
import './style.scss';

class Status extends PureComponent {
    state = {};

    constructor(props) {
        super(props);
        this.refreshTimer = null;
    }

    componentDidUpdate(prevProps, prevState) {
        const { cronstatus, refreshCronStatus } = this.props;
        if (!this.refreshTimer && prevProps.cronstatus === 'inprogress') {
            this.refreshTimer = setInterval(() => {
                refreshCronStatus();
            }, 60000);
        }
        if (
            this.refreshTimer !== null &&
            cronstatus === 'cron' &&
            prevProps.cronstatus === 'inprogress'
        ) {
            this.refreshTimer = null;
        }
    }

    componentWillUnmount() {
        this.refreshTimer = null;
    }

    renderPauseButton() {
        const { cronstatus, pauseCron, resumeCron } = this.props;
        return (
            <ButtonPrimary
                className="btn-primary-pause"
                onClick={cronstatus === 'paused' ? resumeCron : pauseCron}
            >
                <Literal literal={cronstatus === 'paused' ? 'action_resume' : 'action_pause'} />
            </ButtonPrimary>
        );
    }

    render() {
        const {
            cronstatus,
            goToSettings,
            literal_enabled_title,
            literal_enabled_text,
            literal_inprogress_title,
            literal_inprogress_text,
            literal_nocron_title,
            literal_nocron_text,
            literal_checking_title,
            literal_checking_text,
            literal_error_title,
            literal_error_text,
            literal_paused_title,
            literal_paused_text,
            literal_pausing_title,
            literal_pausing_text,
            literal_resuming_title,
            literal_resuming_text,
        } = this.props;
        let configurationButton = (
            <ButtonPrimary className="btn-primary-configuration" onClick={goToSettings}>
                <Literal literal="action_config_integration" />
            </ButtonPrimary>
        );
        switch (cronstatus) {
            case 'enabled':
                return (
                    <div className="integration-inside-tab-content">
                        <SuccessAlert
                            title={
                                <Literal
                                    literal={
                                        literal_enabled_title || 'label_enabled_sync_integration'
                                    }
                                />
                            }
                            text={
                                <Literal
                                    literal={
                                        literal_enabled_text ||
                                        'label_enabled_sync_description_integration'
                                    }
                                />
                            }
                            iconDisplay={'icon'}
                            shrink={true}
                        />
                        <div className="status-tab-button-container">
                            {this.renderPauseButton()}
                        </div>
                    </div>
                );
            case 'inprogress':
                return (
                    <div className="integration-inside-tab-content">
                        <InfoAlert
                            title={
                                <Literal
                                    literal={
                                        literal_inprogress_title || 'label_initial_sync_integration'
                                    }
                                />
                            }
                            text={
                                <Literal
                                    literal={
                                        literal_inprogress_text ||
                                        'label_sync_description_integration'
                                    }
                                />
                            }
                            iconDisplay={'icon'}
                            shrink={true}
                        />
                    </div>
                );
            case 'paused':
                return (
                    <div className="integration-inside-tab-content">
                        <InfoAlert
                            title={
                                <Literal
                                    literal={literal_paused_title || 'label_paused_integration'}
                                />
                            }
                            text={
                                <Literal
                                    literal={
                                        literal_paused_text ||
                                        'label_paused_description_integration'
                                    }
                                />
                            }
                            iconDisplay={'icon'}
                            shrink={true}
                        />
                        <div className="status-tab-button-container">
                            {this.renderPauseButton()}
                        </div>
                    </div>
                );
            case 'no cron':
                return (
                    <div className="integration-inside-tab-content">
                        <WarningAlert
                            title={
                                <Literal
                                    literal={
                                        literal_nocron_title ||
                                        'label_cofiguration_missed_integration'
                                    }
                                />
                            }
                            text={
                                <Literal
                                    literal={
                                        literal_nocron_text ||
                                        'label_cofiguration_missed_desc_integration'
                                    }
                                />
                            }
                            iconDisplay={'icon'}
                            shrink={true}
                        />
                        <div className="status-tab-button-container">{configurationButton}</div>
                    </div>
                );
            case 'checking':
                return (
                    <div className="integration-inside-tab-content">
                        <SpinnerAlert
                            title={
                                <Literal
                                    literal={
                                        literal_checking_title ||
                                        'label_integration_loading_configuration'
                                    }
                                />
                            }
                            text={
                                <Literal
                                    literal={
                                        literal_checking_text ||
                                        'label_integration_loading_configuration_description'
                                    }
                                />
                            }
                            shrink={true}
                        />
                    </div>
                );
            case 'pausing':
                return (
                    <div className="integration-inside-tab-content">
                        <SpinnerAlert
                            title={
                                <Literal
                                    literal={literal_pausing_title || 'label_integration_pausing'}
                                />
                            }
                            text={
                                <Literal
                                    literal={
                                        literal_pausing_text ||
                                        'label_integration_pausing_description'
                                    }
                                />
                            }
                            shrink={true}
                        />
                    </div>
                );
            case 'resuming':
                return (
                    <div className="integration-inside-tab-content">
                        <SpinnerAlert
                            title={
                                <Literal
                                    literal={literal_resuming_title || 'label_integration_resuming'}
                                />
                            }
                            text={
                                <Literal
                                    literal={
                                        literal_resuming_text ||
                                        'label_integration_resuming_description'
                                    }
                                />
                            }
                            shrink={true}
                        />
                    </div>
                );
            case 'error':
                return (
                    <div className="integration-inside-tab-content">
                        <ErrorAlert
                            title={
                                <Literal
                                    literal={literal_error_title || 'label_failed_sync_integration'}
                                />
                            }
                            text={
                                <Literal
                                    literal={
                                        literal_error_text ||
                                        'label_failed_sync_description_integration'
                                    }
                                />
                            }
                            iconDisplay={'icon'}
                            shrink={true}
                        />
                        <div className="status-tab-button-container">{configurationButton}</div>
                    </div>
                );
            default:
                return (
                    <div className="integration-inside-tab-content">
                        <div className="status-tab-button-container">{configurationButton}</div>
                    </div>
                );
        }
    }
}

export default Status;
